import { JSX, useCallback, useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export type FeedbackButtonProps = {
	label: string;
	disabled?: boolean;
	fullWidth?: boolean;
	variant?: "text" | "outlined" | "contained";

	onClick?: () => Promise<void>;
};

function FeedbackButton(props: FeedbackButtonProps): JSX.Element {
	const [loading, setLoading] = useState(false);

	const handleClick = useCallback((): void => {
		if (props.onClick === undefined) {
			return;
		}

		setLoading(true);
		props.onClick().finally(() => setLoading(false));
	}, [props.onClick]);

	return (
		<Box sx={{ position: "relative" }}>
			<Button
				variant={props.variant}
				disabled={loading || props.disabled}
				fullWidth={props.fullWidth}
				onClick={handleClick}>
				{props.label}
			</Button>
			{loading && (
				<CircularProgress
					size={24}
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						marginTop: "-12px",
						marginLeft: "-12px"
					}}
				/>
			)}
		</Box>
	);
}

export default FeedbackButton;
